var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout",attrs:{"id":"app"}},[_c('AppHeader'),_c('div',{staticClass:"layout__content"},[_c('router-view')],1),_c('AppFooter',{attrs:{"title":"Mike"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }